import _ from "lodash";
import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import QueryString from "query-string";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/react";

import { activateAccount } from "../../modules";
import { AppStateDisplay, clearAll } from "../../../common";
import strings from "../../../../res/strings";

import styled from "styled-components";
const Panel = styled.div`
  background: rgba(255, 255, 255, 0.15);
  height: 100vh;
`;

let AccountActivationPanel = (props) => {
  useEffect(() => {
    const values = {
      token: _.get(props.parsedQuery, "token"),
      uid: _.get(props.parsedQuery, "uid"),
    };

    props.activateAccount({
      values,
      successState: {
        notificationType: "banner",
        context: "lib_authentication.activateAccount.accountActivationPage",
        title: strings.lib_authentication_state_success_activate_account,
        message:
          strings.lib_authentication_state_success_activate_account_details,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_proceed,
            onClick: () => {
              props.clearAll();
              props.setRightPanel("LOGIN");
            },
          },
        ],
      },
      errorState: (error) => ({
        ...error,
        notificationType: "banner",
        context: "lib_authentication.activateAccount.accountActivationPage",
        title: strings.lib_authentication_state_error_activate_account,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_back,
            onClick: () => {
              props.clearAll();
              props.setRightPanel("LOGIN");
            },
          },
        ],
      }),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel>
      <AppStateDisplay parsedQuery={props.parsedQuery} />
    </Panel>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      activateAccount,
      clearAll,
    },
    dispatch
  );

AccountActivationPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountActivationPanel);

export { AccountActivationPanel };

const AccountActivationPage = (props) => {
  const parsedQuery = QueryString.parse(props.location.search);

  useEffect(() => {
    const values = {
      token: parsedQuery.token,
      uid: parsedQuery.uid,
    };

    props.activateAccount({
      values,
      successState: {
        notificationType: "banner",
        context: "lib_authentication.activateAccount.accountActivationPage",
        title: strings.lib_authentication_state_success_activate_account,
        message:
          strings.lib_authentication_state_success_activate_account_details,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_proceed,
            path: "/auth",
          },
        ],
      },
      errorState: (error) => ({
        ...error,
        notificationType: "banner",
        context: "lib_authentication.activateAccount.accountActivationPage",
        title: strings.lib_authentication_state_error_activate_account,
        redirects: [
          {
            label: strings.lib_authentication_redirect_login_back,
            path: "/auth",
          },
        ],
      }),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {strings.lib_authentication_title_account_activation}
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <AppStateDisplay parsedQuery={parsedQuery} />
      </IonContent>
    </IonPage>
  );
};

export default AccountActivationPage;
